import script from "./OrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderList.vue?vue&type=script&setup=true&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=9c4341aa&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c4341aa"]])

export default __exports__